import { useEffect } from "react";

// Polls whether the current org's rights feature (onBoardingRightsId) is enabled, refetching
// whenever PracticeId/token change. fetchAccessRights itself already takes rightsId/token/
// practiceId as explicit args (not just the values current at mount), so callers elsewhere in
// Home.jsx can request a different feature's rights on demand.
export const useAccessRights = ({
  token,
  PracticeId,
  onBoardingRightsId,
  dateRangeRequest,
  setIsRightsLoad,
  setIsTokenExpired,
  setRightsEnabled,
}) => {
  const fetchAccessRights = async (rightsId, requestToken, practiceId) => {
    setIsRightsLoad(true);

    const obj = { featureId: rightsId ? rightsId : 1 };
    const userData = await dateRangeRequest(
      requestToken,
      `/api/getAccessRightsDetails/${practiceId}`,
      obj,
    );
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true);
    } else if (userData == "No record") {
      setRightsEnabled(false);
    } else {
      const enabled =
        Boolean(userData) &&
        (userData.RightsEnabled === true ||
          userData.RightsDetail === "true" ||
          userData.RightsDetail === true);
      setRightsEnabled(enabled);
    }

    setIsRightsLoad(false);
  };

  useEffect(() => {
    if (PracticeId && token) {
      fetchAccessRights(onBoardingRightsId, token, PracticeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PracticeId, token]);

  return { fetchAccessRights };
};
